export default __webpack_public_path__ + "static/media/icon-share-via-whatsapp.085907c4.svg";